import { useState, useEffect } from "react";
import { searchConfigurationsByKeys } from "../services/api/Configurations/ConfigurationService";
import { IApiResponse } from "../@types/api-response.type";
import { IConfiguration } from "../@types/configuration.type";

const SYNC_CONFIGURATION_KEYS = [
  "CONFIGURATION_CONVENIA_TOKEN",
  "CONFIGURATION_LG_USER",
  "CONFIGURATION_LG_PASSWORD",
  "CONFIGURATION_LG_URL",
  "CONFIGURATION_LG_ENVIRONMENT",
  "CONFIGURATION_LG_GUIDTENANT",
];

export const useSyncActive = (): boolean => {

  const [isSyncActive, setIsSyncActive] = useState<boolean>(false);

  useEffect(() => {
    searchConfigurationsByKeys(SYNC_CONFIGURATION_KEYS)
      .then((response) => {
        const configs = (response as IApiResponse<IConfiguration[]>).result;
        const isConfigured = configs.some((c) => c.value !== "");
        setIsSyncActive(isConfigured);
      })
      .catch(() => {
        setIsSyncActive(false);
      });
  }, [setIsSyncActive]);

  return isSyncActive;
};
